exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1mMS1h3BPL4xs3{padding-top:12px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Noto Sans,Ubuntu,Droid Sans,Helvetica Neue,sans-serif;font-size:12px;line-height:20px}._1mMS1h3BPL4xs3 ._3tk_80j9bv7Jtd{color:#6b778c;text-decoration:none}._1mMS1h3BPL4xs3 ._3tk_80j9bv7Jtd:hover{text-decoration:underline}.QGJUGfU6McaBJQ{margin-top:8px;padding:6px 10px;border-radius:3px;background-color:#42548e;color:#fff;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Noto Sans,Ubuntu,Droid Sans,Helvetica Neue,sans-serif;font-size:12px;line-height:20px}.QGJUGfU6McaBJQ .syVPfVO_cJn-ez{margin-top:14px}.QGJUGfU6McaBJQ .syVPfVO_cJn-ez ._3tk_80j9bv7Jtd{color:#a5adba;text-decoration:none}.QGJUGfU6McaBJQ .syVPfVO_cJn-ez ._3tk_80j9bv7Jtd:hover{text-decoration:underline}.QGJUGfU6McaBJQ p>a{color:#fff}", ""]);

// exports
exports.locals = {
	"whiteBox": "_1mMS1h3BPL4xs3",
	"learnMoreLink": "_3tk_80j9bv7Jtd",
	"purpleBox": "QGJUGfU6McaBJQ",
	"learnMoreLinkContainer": "syVPfVO_cJn-ez"
};